// (c) chaehongee. Confidential and proprietary.

import { useCallback, useState } from 'react'
import type { MenuAnchor, MenuTarget } from './types'

export interface UseContextMenuResult {
    open: boolean
    anchor: MenuAnchor | null
    target: MenuTarget | null
    openWithEvent: (target: MenuTarget, e: MouseEvent) => void
    close: () => void
    setTarget: (t: MenuTarget | null) => void
}

export function useContextMenu(containerRef: React.RefObject<HTMLElement | null>): UseContextMenuResult {
    const [open, setOpen] = useState(false)
    const [anchor, setAnchor] = useState<MenuAnchor | null>(null)
    const [target, setTarget] = useState<MenuTarget | null>(null)

    const close = useCallback(() => setOpen(false), [])

    const openWithEvent = useCallback((t: MenuTarget, e: MouseEvent) => {
        e.preventDefault()
        const el = containerRef.current
        if (!el) return
        const r = el.getBoundingClientRect()
        setAnchor({ x: e.clientX - r.left, y: e.clientY - r.top })
        setTarget(t)
        setOpen(true)
    }, [containerRef])

    return { open, anchor, target, openWithEvent, close, setTarget }
}

export default useContextMenu

